import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const citySlug = (name = "") =>
  name
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();

export const fetchCities = () => axios.get(`${API}/cities`).then((r) => r.data || []);
